import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

interface StyledSliderEditorProps {
	isVisible: boolean;
}

interface BorderProps {
	borderWidth: number;
	isActive: boolean;
}

const StyledSliderEditor = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	pointer-events: auto;

	${({ isVisible }: StyledSliderEditorProps) => isVisible && `
		background-color: ${NewStyleColor.Grey200};
	`}
`;

const IconWrapper = styled('div')`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 30%;
	max-width: 150px;
	color: ${NewStyleColor.Grey400};

	svg {
		width: 100%;
		fill: currentColor;
	}
`;

const Border = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	border: ${({ borderWidth }: BorderProps) => `${borderWidth}px`}
		solid
		${({ isActive }: BorderProps) => isActive ? `${NewStyleColor.Blue100}` : `${NewStyleColor.Grey400}`};
	border-radius: inherit;
`;

export {
	StyledSliderEditor,
	IconWrapper,
	Border,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/SliderEditor/styles.ts